<template>
  <r-panel :disabled="disabled" title="Level Tiles">
    <r-level-track-level-field-tiles-view :model.sync="value"/>
  </r-panel>
</template>

<script>
import VueTypes from 'vue-types';
import RPanel from '@/modules/redactor/views/utils/r-panel.vue';
import RLevelTrackLevelFieldTilesView from "@/modules/redactor/views/level-track/level/field/tiles/r-level-track-level-field-tiles-view.vue";

export default {
  name: "r-level-track-level-field-tiles-panel",
  components: { RPanel, RLevelTrackLevelFieldTilesView },
  props: {
    disabled: VueTypes.bool.def(false),
    model: VueTypes.arrayOf(VueTypes.arrayOf(VueTypes.String))
  },
  computed: {
    value: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      }
    }
  }
}
</script>
